import { useEffect, useState } from "react";
import customAxios from "../../../../utils/customAxios";
import setAuthToken from "../../../../utils/setAuthToken";

export default function useAdmin() {
    const [admins, setAdmins] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        setIsLoading(true);
        setError(null);
        if (localStorage.token) {
            setAuthToken(localStorage.token);
        }
        customAxios.get("/api/admin/users?limit=100&page=1&orderBy=_id&sortBy=asc&role=admin")
            .then((res) => {
                const apiRes = res.data;
                const users = apiRes?.data?.data || [];
                setAdmins(
                    users.map((user) => ({
                        value: user._id || user.id,
                        label: user.name || user.email || user.username,
                    }))
                );
                setIsLoading(false);
            })
            .catch((err) => {
                setError(err.message || "Unknown error");
                setIsLoading(false);
            });
    }, []);

    return { admins, isLoading, error };
}
